function Tabs(props) {
  let {
    role = "tablist",
    rounded = false,
    disabled = false,
    options,
    value,
    onSelect,
    id
  } = props;

  let t = role === "tablist";

  return (
    <ul className="mc-tabs" role={t ? "tablist" : "radiogroup"} id={id} data-rounded={rounded} aria-disabled={disabled}>
      {options.map(function (opt) {
        let selected = opt.value === value;
        let src = null;

        if (opt.icon) {
          src = opt.icon.indexOf(".") === 0 ? opt.icon : ("./img/mc/icon." + opt.icon + ".svg");
        }

        return (
          <li
            key={opt.value}
            role={t ? "tab" : "radio"}
            aria-selected={t ? selected : null}
            aria-checked={!t ? selected : null}>
              <button disabled={disabled || opt.disabled} onClick={onSelect.bind(null, opt.value, !selected)}>
                {src ? (
                  <img src={src} height="18"/>
                ) : null}
                <span>{opt.label}</span>
              </button>
          </li>
        );
      })}
    </ul>
  );
};

module.exports = Tabs;
